let abs = function(value) {
  return Math.abs(value);
};

export default {
  install: function (Vue) {
    Vue.filter('abs', abs);
  }
}
